export default __webpack_public_path__ + "static/media/fit-food-vebsayt.dbc89c02.jpg";